module.exports = __webpack_public_path__ + "static/media/header.84a07340.jpg";